export default __webpack_public_path__ + "static/media/rawbg.f61fad64.png";